import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useDesktopDisplay from '../../../hooks/useDesktopDisplay';
import {
  setHeaderConfigsAction,
  setHeaderTitleAction
} from '../../../reactRedux/Actions/headerAction';
import classNames from 'classnames';
import styles from './styles.module.scss';
import Switch from '@material-ui/core/Switch';
import Loader from '../../common/Loader';
import {
  useGetOrganizationFeatures,
  useGetUserSetting,
  useUpdateUserSetting
} from '../../../hooks/httpRequests';
import { useTranslation } from '../../../i18n/LanguageProvider';

const SettingsNotifications = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useDesktopDisplay();
  const updateUserSetting = useUpdateUserSetting();
  const setHeader = (title) => dispatch(setHeaderTitleAction(title));
  const setHeaderConfigs = (configs) =>
    dispatch(setHeaderConfigsAction(configs));

  const { data: userSettingData, isLoading: settingLoading } =
    useGetUserSetting();
  const { data: organizationFeatures_Data, isLoading: featuresLoading } =
    useGetOrganizationFeatures();

  const [values, setValues] = useState({
    announcementNotification: false,
    kudosNotification: false,
    feedbackNotification: false,
    reminderNotification: false
  });

  useEffect(() => {
    if (!settingLoading) {
      setValues({
        announcementNotification: userSettingData?.announcement_notification,
        kudosNotification: userSettingData?.kudos_notification,
        feedbackNotification: userSettingData?.feedback_notification,
        reminderNotification: userSettingData?.mood_reminder_notification
      });
    }
  }, [settingLoading]);

  useEffect(() => {
    setHeader(t('settings.notifications'));
    setHeaderConfigs({ credits: false, exit: false, back: true });
  }, []);

  const onChangeHandler = (event) => {
    const { name, checked } = event.target;
    setValues((prev) => {
      const updatedValues = { ...prev, [name]: checked };
      updateUserSetting.mutate({
        data: {
          announcement_notification: updatedValues.announcementNotification,
          feedback_notification: updatedValues.feedbackNotification,
          kudos_notification: updatedValues.kudosNotification,
          mood_reminder_notification: updatedValues.reminderNotification
        }
      });
      return updatedValues;
    });
  };

  const showReminderField = organizationFeatures_Data?.find(
    (item) => item.feature_name === 'reminder_push_notification'
  )?.active;

  return (
    <div className={classNames(styles.page, styles.full)}>
      {isDesktop && (
        <div className={styles.pageHeader}>{t('settings.notifications')}</div>
      )}
      <div className={styles.section}>
        <div className={styles.sectionBody}>
          {settingLoading || featuresLoading ? (
            <Loader />
          ) : (
            <div className={styles.switchGroup}>
              <div>{t('settings.notifyKudos')}</div>
              <Switch
                name="kudosNotification"
                checked={values?.kudosNotification}
                onChange={onChangeHandler}
              />
              <div>{t('settings.notifyAnnouncement')}</div>
              <Switch
                name="announcementNotification"
                checked={values?.announcementNotification}
                onChange={onChangeHandler}
              />
              <div>{t('settings.notifyConversation')}</div>
              <Switch
                name="feedbackNotification"
                checked={values?.feedbackNotification}
                onChange={onChangeHandler}
              />
              {showReminderField && (
                <>
                  <div>{t('settings.notifyMoodReminder')}</div>
                  <Switch
                    name="reminderNotification"
                    checked={values?.reminderNotification}
                    onChange={onChangeHandler}
                  />
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SettingsNotifications;
